<!-- 
  详情页 - 客户联系人
  props:
    id: 详情id
 -->

<template>
  <div class="contacts">
    <ul class="item-list">
      <li class="item center" v-if="!contactData.length">暂无联系人</li>
      <li class="item" v-for="item in contactData" :key="item.id">
        <div class="infos">
          <div class="user">
            <a class="text" :style=titColor @click="detail(item.id)">{{item.name}}</a>
            <span class="tag">{{item.level}}</span>
            <span v-if="item.isMain" class="tag master">关键决策人</span>
            <template v-if="mainContact">
              <template v-if="item.isMainContact">
                <span class="tag mainContact">主联系人</span>
                <el-tooltip content="主联系人只有一个，设置成功后将会在客户列表页便捷查看主联系人。" placement="bottom" effect="light">
                  <span class="icon el-icon-question"></span>
                </el-tooltip>
              </template>
              <el-button v-else class="button" type="text" size="small" @click="setMessageBox(item)">设为主联系人</el-button>
            </template>
          </div>
          <p class="phone">Tel：{{item.phone | arrToStr}}</p>
          <span class="position">{{item.position}}</span>
        </div>
      </li>
    </ul>

    <div class="load-more">
      <template v-if="showLoadmore">
        <i class="el-icon-loading"></i>
        加载更多
      </template>
      <template v-if="!showLoadmore && page.total>page.size">没有更多</template>
    </div>
  </div>
</template>

<script>
import * as api from 'src/api'
import { Message, MessageBox } from 'element-ui'

export default {
  created () {
    this.getList()
  },
  props: {
    id: {
      type: Number
    },
    loading: {
      type: Number,
      default: 1
    }
  },
  data () {
    return {
      contactData: [],
      // 分页信息
      page: {
        size: 10,
        total: '',
        page: 1,
        rows: 1
      },
      titColor: {
        color: '#008cee'
      },
      mainContact: false
    }
  },
  computed: {
    // 是否显示加载更多
    showLoadmore () {
      if (this.page.total > this.page.size && this.page.rows > this.page.page) {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    // 打开联系人详情
    detail (id) {
      this.$emit('openDetail', 'contactApi', id)
    },
    getList () {
      let url = '/contactApi/getCustomerContact.html'
      let params = {
        refType: 'customer',
        refId: this.id,
        page: this.page.page,
        pageSize: this.page.size
      }
      api.post(url, params, (data) => {
        this.page.total = data.pageHelper.rowsCount
        this.page.rows = data.pageHelper.pageTotal
        this.mainContact = data.mainContact

        // 通过page.page来判断当前是刷新还是下拉加载更多
        if (this.page.page === 1) {
          this.contactData = data.result
        } else {
          this.contactData = this.contactData.concat(data.result)
        }
      })
    },
    setMessageBox (item) {
      MessageBox.confirm('是否将“' + item.name + '”设置为主联系人?', '确认', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.setIsMainContact(item.id)
      }).catch(() => {})
    },
    setIsMainContact (id) {
      let url = '/contactApi/setMainContact.html'
      let params = {
        id: id,
        isMainContact: true
      }
      api.post(url, params, (data) => {
        Message({
          type: 'success',
          message: data.msg || '设置成功！'
        })
        this.getList()
      })
    },
    // 加载更多
    loadmore () {
      this.page.page++
      this.getList()
    }
  },
  watch: {
    loading () {
      if (this.page.rows > this.page.page) {
        this.loadmore()
      }
    }
  },
  filters: {
    arrToStr (arr) {
      let nums = arr.map((item) => {
        return item.telNum
      })
      return nums.join('/')
    }
  }
}
</script>

<style lang="less" scoped>
  @import '../../../assets/less/detail-contact.less';
</style>


// WEBPACK FOOTER //
// contact.vue?4b842175